function oklabValuesToRgb(L: number, a: number, b: number, alpha = 1): string {
  const l_ = L + 0.3963377774 * a + 0.2158037573 * b;
  const m_ = L - 0.1055613458 * a - 0.0638541728 * b;
  const s_ = L - 0.0894841775 * a - 1.291485548 * b;
  const l = Math.max(0, l_) ** 3, m = Math.max(0, m_) ** 3, s = Math.max(0, s_) ** 3;
  const r = +4.0767439362 * l - 3.3077115913 * m + 0.2309699292 * s;
  const g = -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s;
  const b_ = -0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s;
  const gamma = (c: number) =>
    Math.round(Math.min(255, Math.max(0, (c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(Math.max(0, c), 1 / 2.4) - 0.055) * 255)));
  const R = gamma(r), G = gamma(g), B = gamma(b_);
  return alpha < 1 ? `rgba(${R}, ${G}, ${B}, ${alpha})` : `rgb(${R}, ${G}, ${B})`;
}

export function sanitizeColorString(str: string): string {
  if (!str || typeof str !== 'string') return str;
  if (!str.includes('oklab') && !str.includes('oklch') && !str.includes('color-mix')) return str;
  let res = str
    .replace(/oklab\(\s*([^\s,/)]+)[\s,]+([^\s,/)]+)[\s,]+([^\s,/)]+)(?:[\s,/]+([^\s,/)]+))?\s*\)/gi, (_m, l, a, b, alpha) => {
      let L = parseFloat(l); if (l.endsWith('%')) L /= 100;
      const aVal = parseFloat(a), bVal = parseFloat(b);
      let alp = alpha !== undefined ? parseFloat(alpha) : 1;
      if (typeof alpha === 'string' && alpha.endsWith('%')) alp /= 100;
      return oklabValuesToRgb(L, aVal, bVal, isNaN(alp) ? 1 : alp);
    })
    .replace(/oklch\(\s*([^\s,/)]+)[\s,]+([^\s,/)]+)[\s,]+([^\s,/)]+)(?:[\s,/]+([^\s,/)]+))?\s*\)/gi, (_m, l, c, h, alpha) => {
      let L = parseFloat(l); if (l.endsWith('%')) L /= 100;
      const C = parseFloat(c), H = parseFloat(h);
      let alp = alpha !== undefined ? parseFloat(alpha) : 1;
      if (typeof alpha === 'string' && alpha.endsWith('%')) alp /= 100;
      const hRad = ((isNaN(H) ? 0 : H) * Math.PI) / 180;
      return oklabValuesToRgb(L, (isNaN(C) ? 0 : C) * Math.cos(hRad), (isNaN(C) ? 0 : C) * Math.sin(hRad), isNaN(alp) ? 1 : alp);
    });
  if (res.includes('color-mix')) res = res.replace(/color-mix\([^)]*\)/gi, 'rgb(30, 41, 59)');
  if (res.includes('oklab') || res.includes('oklch')) {
    res = res.replace(/oklab\([^)]*\)/gi, 'rgb(30, 41, 59)').replace(/oklch\([^)]*\)/gi, 'rgb(30, 41, 59)');
  }
  return res;
}

export function wrapStyleDecl(decl: CSSStyleDeclaration): CSSStyleDeclaration {
  return new Proxy(decl, {
    get(target, prop) {
      const val = Reflect.get(target, prop, target);
      if (typeof val === 'string') return sanitizeColorString(val);
      if (typeof val === 'function') {
        return (...args: any[]) => {
          const res = (val as any).apply(target, args);
          return typeof res === 'string' ? sanitizeColorString(res) : res;
        };
      }
      return val;
    },
  });
}

export function patchWindowStyles(win: Window): () => void {
  const original = win.getComputedStyle;
  win.getComputedStyle = (elt: Element, pseudoElt?: string | null) => {
    const comp = original.call(win, elt, pseudoElt);
    return wrapStyleDecl(comp);
  };
  return () => {
    win.getComputedStyle = original;
  };
}
